<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-demonstration`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26 39h7a1 1 0 011 1v2a1 1 0 01-1 1H15a1 1 0 01-1-1v-2a1 1 0 011-1h7v-6H9a2 2 0 01-2-2V9H5a1 1 0 01-1-1V6a1 1 0 011-1h38a1 1 0 011 1v2a1 1 0 01-1 1h-2v22a2 2 0 01-2 2H26v6zm-5-25.74a.6.6 0 01.978-.465l6.449 5.24a.6.6 0 010 .93l-6.449 5.24A.6.6 0 0121 23.74V13.261zM37 9H11v20h26V9z"/></svg>
</template>
<script>

export default {
  name: 'IconDemonstration',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
